export default {"src":"/_next/static/media/lucky7Ventures.ba07fc2c.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};